import { communicationInstance } from 'store';

export class CommunicationApi {
  public static getCommunication = (params?: {
    [key: string]: string | number;
  }) => communicationInstance.get('/api/communications', { params });
}
